import { useState, useEffect } from "react";
import { DollarSign, Activity } from "lucide-react";

interface LiveCounterProps {
  initialAmount: number;
  incrementPerSecond: number;
}

export function LiveCounter({ initialAmount, incrementPerSecond }: LiveCounterProps) {
  const [amount, setAmount] = useState(initialAmount);

  useEffect(() => {
    const interval = setInterval(() => {
      setAmount(prev => prev + incrementPerSecond);
    }, 1000);

    return () => clearInterval(interval);
  }, [incrementPerSecond]);

  const formatAmount = (num: number) => {
    return num.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  };

  return (
    <div className="terminal-card p-5 sm:p-6 lg:p-8 text-center bg-gradient-corruption mx-3 sm:mx-2">
      <div className="flex items-center justify-center mb-4 sm:mb-4">
        <Activity className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-blood-red mr-2 sm:mr-3 animate-pulse" />
        <h2 className="text-base sm:text-lg lg:text-xl font-bold text-foreground leading-tight">
          Total Healthcare Overcharges Today
        </h2>
      </div>

      <div className="flex items-center justify-center mb-3 overflow-hidden">
        <DollarSign className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 text-blood-red flex-shrink-0" />
        <div className="font-mono text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-blood-red glitch cascade-number break-all"
             data-text={formatAmount(amount).replace('$', '')}>
          {formatAmount(amount).replace('$', '')}
        </div>
      </div>

      <div className="text-sm sm:text-base text-muted-foreground font-mono">
        +${incrementPerSecond.toLocaleString()} per second
      </div>
    </div>
  );
}